import client from '@stores/apollo'
import gql from 'graphql-tag'
import handleFetchResult from '@utils/handleFetchResult'
import { ImportSummaryData } from 'components/ImportFlow/hooks/useImportSummary'
import { DocumentNode } from 'graphql'

interface IPayload {
  node: ImportSummaryData
}

const mutateHandler = handleFetchResult<IPayload, ImportSummaryData>({
  handler: (data) => data.node,
  name: 'Summary',
})

export default function summary(id: string, query: DocumentNode): Promise<ImportSummaryData> {
  return client.gql
    .query({
      query: gql`
        ${query}
      `,
      variables: { id },
    })
    .then(mutateHandler)
}
